<div class="outer-wrapper">
  <app-header></app-header>
  <div
    class="col-md-2 bg-light left-menu shadow-sm side-items animate__animated animate__fadeInLeft"
  >
    <div>
      <h3 class="mt-5">My Account</h3>
      <ul class="ml-3">
        <li
          (click)="pricingPlanClickEvent()"
          [ngClass]="pricingPlan == true ? 'active-item' : ''"
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              /></svg></span
          >Pricing Plan
        </li>
        <li
          (click)="planAndSubscriptionsClickEvent()"
          [ngClass]="planAndSubscriptions == true ? 'active-item' : ''"
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              /></svg></span
          >Plan & Subscription
        </li>
        <li
          (click)="changepassword()"
          [ngClass]="chngePasswodformshow == true ? 'active-item' : ''"
        >
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              /></svg></span
          >Change Password
        </li>
        <li (click)="goBack()">
          <span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
              /></svg></span
          >Back
        </li>
      </ul>
    </div>
  </div>
  <div class="col-md-10 right-content">
    <div class="container mt-5 pt-4">
      <div class="row" *ngIf="planAndSubscriptions">
        <div class="col-md-6 mb-5">
          <div class="card p-3 shadow text-center">
            <div class="card-header text-center mb-3">
              <h4 class="my-0 font-weight-normal bg-green">
                Plan and Subscription
              </h4>
            </div>
            <!-- <p>Your current plan and subscription information goes here.</p> -->
            <div *ngIf="subscriptionData" style="padding: 30px">
              <ng-container
                *ngIf="
                  subscriptionData.subscriptionType !== 'SUBSCRIBED_VIA_ORG'
                "
              >
                <h4>{{ CurrentInfo(subscriptionData) }}</h4>
                <ng-container
                  *ngIf="
                    subscriptionData.subscriptionStatus === 'ON_GOING';
                    else expiredCancelledBlock
                  "
                >
                  <p>
                    Your subscription is active till:
                    {{ formatDate(subscriptionData.validTill) }}
                  </p>
                </ng-container>
                <ng-template #expiredCancelledBlock>
                  <p *ngIf="subscriptionData.subscriptionStatus === 'EXPIRED'">
                    expired on
                    {{ formatDate(subscriptionData.expiredAt) }}
                  </p>
                  <p
                    *ngIf="subscriptionData.subscriptionStatus === 'CANCELLED'"
                  >
                    cancelled on
                    {{ formatDate(subscriptionData.cancelledAt) }}
                  </p>
                </ng-template>
              </ng-container>
              <ng-container
                *ngIf="
                  subscriptionData.subscriptionType == 'SUBSCRIBED_VIA_ORG'
                "
              >
                <div class="card mb-4 box-shadow shadow">
                  <div class="card-header text-center">
                    <h4 class="my-0 font-weight-normal">
                      Your subscription is currently active as a part of
                      {{ organizationname.orgRef.name }}'s service bundle.
                    </h4>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="col-md-6 mb-5">
          <div class="card p-3 shadow" *ngIf="!userProfile.subscribedUser">
            <div class="card-header text-center mb-3">
              <h4 class="my-0 font-weight-normal text-info">
                Cancel Subscription
              </h4>
            </div>
            <!-- <h2 class="text-info">Cancel Subscription</h2> -->
            <p>
              If you wish to cancel your subscription, then press the below
              cancel button.
            </p>
            <br />
            <button
              type="button"
              class="btn btn-lg btn-block btn-outline-primary"
              (click)="onCancelSubscription()"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>

      <div class="row" *ngIf="pricingPlan">
        <div
          class="col-md-4 mt-4 month-col"
          *ngFor="let priceItem of priceList"
        >
          <div class="card mb-4 box-shadow shadow">
            <div class="card-header text-center">
              <span
                class="best-vl"
                *ngIf="priceItem?.recurring?.interval == 'year'"
                >Best Value</span
              >
              <h4
                class="my-0 font-weight-normal"
                [ngClass]="{
                  'bg-green':
                    getPriceTitle(priceItem?.recurring?.interval) == 'Annual'
                }"
              >
                {{ getPriceTitle(priceItem?.recurring?.interval) }}
              </h4>
            </div>
            <div class="card-body text-center">
              <h1 class="card-title pricing-card-title">
                <span>
                  <span
                    class="special-price annual-col"
                    *ngIf="priceItem?.unit_amount == 60"
                    [ngClass]="{
                      'bg-green':
                        getPriceTitle(priceItem?.recurring?.interval) ==
                        'Annual'
                    }"
                  >
                    <span
                      class="text-decoration-line-through mr-1 annual-col"
                      [ngClass]="{
                        'bg-green':
                          getPriceTitle(priceItem?.recurring?.interval) ==
                          'Annual'
                      }"
                      >$100</span
                    >
                  </span>
                  <span
                    class="special-price"
                    *ngIf="priceItem?.unit_amount == 1000"
                    [ngClass]="{
                      'bg-green':
                        getPriceTitle(priceItem?.recurring?.interval) ==
                        'Annual'
                    }"
                  >
                    <span
                      class="text-decoration-line-through mr-1"
                      [ngClass]="{
                        'bg-green':
                          getPriceTitle(priceItem?.recurring?.interval) ==
                          'Annual'
                      }"
                      >$1200</span
                    >
                  </span>
                  <small
                    [ngClass]="{
                      'bg-green':
                        getPriceTitle(priceItem?.recurring?.interval) ==
                        'Annual'
                    }"
                    >{{ getPriceAmount(priceItem) }}</small
                  >
                </span>

                <small
                  class="text-muted"
                  [ngClass]="{
                    'bg-green':
                      getPriceTitle(priceItem?.recurring?.interval) == 'Annual'
                  }"
                  >/ {{ getPriceLabel(priceItem?.recurring?.interval) }}</small
                >
              </h1>
              <ul
                class="list-styled list-group-flush text-left mt-3 mb-4"
                *ngIf="priceItem?.recurring?.interval == 'month'"
              >
                <li>{{ getPriceAmount(priceItem) }}/month.</li>
                <li>Limited comparisons</li>
                <li>Scholarship comparison.</li>
              </ul>
              <ul
                class="list-styled list-group-flush text-left mt-3 mb-4"
                *ngIf="priceItem?.recurring?.interval == 'year'"
              >
                <li>Works out to Equivalent to $5/month.</li>
                <li>Same features as monthly plan​.</li>
                <li>Access to bundled features and early previews.</li>
                <li>Priority customer support.</li>
              </ul>
              <button
                type="button"
                class="btn btn-lg btn-block btn-outline-success"
                [ngClass]="{
                  'btn-green':
                    getPriceTitle(priceItem?.recurring?.interval) == 'Annual'
                }"
                (click)="submit(priceItem.priceStripeId)"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>

        <!-- <div class="col-md-4 mt-4" *ngFor="let priceItem of priceList">
            <div class="card mb-4 box-shadow shadow">
              <div class="card-header text-center" >
                <h4 class="my-0 font-weight-normal">Free</h4>
              </div>
              <div class="card-body text-center">
                <h1 class="card-title pricing-card-title text-success">
                  {{ "$" + priceItem?.unit_amount }} <small class="text-muted">/ {{
                    getPriceLabel(priceItem.recurring?.interval)
                  }}</small>
                </h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>10 users included</li>
                  <li>2 GB of storage</li>
                  <li>Email support</li>
                  <li>Help center access</li>
                </ul>
                <button
                  type="button"
                  class="btn btn-lg btn-block btn-outline-success"
                >
                  Start Trial
                </button>
              </div>
            </div>
          </div> -->
        <!-- <div class="col-md-4 mt-4">
            <div class="card mb-4 box-shadow shadow">
              <div class="card-header text-center">
                <h4 class="my-0 font-weight-normal">Pro</h4>
              </div>
              <div class="card-body text-center">
                <h1 class="card-title pricing-card-title text-primary">
                  $15 <small class="text-muted">/ mo</small>
                </h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>Add or manage multiple Student Accounts</li>
                  <li>Quickly share reports</li>
                  <li>Access to bundled features and early previews</li>
                  <li>Email Support</li>
                </ul>
                <button
                  type="button"
                  class="btn btn-lg btn-block btn-outline-primary"
                >
                  Get started
                </button>
              </div>
            </div>
          </div> -->
        <!-- <div class="col-md-4 mt-4">
            <div class="card mb-4 box-shadow shadow">
              <div class="card-header text-center">
                <h4 class="my-0 font-weight-normal">Enterprise</h4>
              </div>
              <div class="card-body text-center">
                <h1 class="card-title pricing-card-title text-warning">
                  $29 <small class="text-muted">/ mo</small>
                </h1>
                <ul class="list-unstyled mt-3 mb-4">
                  <li>30 users included</li>
                  <li>15 GB of storage</li>
                  <li>Phone and email support</li>
                  <li>Help center access</li>
                </ul>
                <button
                  type="button"
                  class="btn btn-lg btn-block btn-outline-warning"
                >
                  Sign up for free
                </button>
              </div>
            </div>
          </div> -->
      </div>
      <div class="row justify-content-center" *ngIf="chngePasswodformshow">
        <form #changePasswordForm="ngForm" autocomplete="off" class="col-md-6">
          <div class="form-group fm-row">
            <label for="username">Username:</label>
            <input
              type="text"
              id="username"
              name="username"
              class="form-control"
              [(ngModel)]="username"
              disabled
              required
            />
          </div>
          <div class="form-group fm-row">
            <label for="oldPassword">Old Password:</label>
            <div class="relative">
              <div
                class="absolute"
                style="position: absolute; top: 12px; right: 13px"
              >
                <svg
                  (click)="hide = !hide"
                  *ngIf="hide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  />
                </svg>
                <svg
                  (click)="hide = !hide"
                  *ngIf="!hide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>
              <input
                type="password"
                id="oldPassword"
                name="oldPassword"
                class="form-control"
                [(ngModel)]="oldPassword"
                [type]="hide ? 'password' : 'text'"
                required
              />
            </div>
          </div>
          <div class="form-group fm-row">
            <label for="newPassword">New Password:</label>
            <div class="relative">
              <div
                class="absolute"
                style="position: absolute; top: 12px; right: 13px"
              >
                <svg
                  (click)="newhide = !newhide"
                  *ngIf="newhide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  />
                </svg>
                <svg
                  (click)="newhide = !newhide"
                  *ngIf="!newhide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>

              <input
                type="password"
                class="form-control"
                id="newPassword"
                name="newPassword"
                [(ngModel)]="newPassword"
                [type]="newhide ? 'password' : 'text'"
                required
              />
            </div>
          </div>
          <div class="form-group fm-row">
            <label for="confirmPassword">Confirm Password:</label>
            <div class="relative">
              <div
                class="absolute"
                style="position: absolute; top: 12px; right: 13px"
              >
                <svg
                  (click)="confirmhide = !confirmhide"
                  *ngIf="confirmhide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                  />
                </svg>
                <svg
                  (click)="confirmhide = !confirmhide"
                  *ngIf="!confirmhide"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-gray-500 cursor-pointer eyes-icon"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                  />
                </svg>
              </div>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                class="form-control"
                [(ngModel)]="confirmPassword"
                [type]="confirmhide ? 'password' : 'text'"
                required
              />
            </div>
            <div
              *ngIf="newPassword !== confirmPassword && confirmPassword !== ''"
              class="text-danger"
            >
              Passwords do not match.
            </div>
          </div>
          <button
            type="button"
            class="btn btn-primary page-btn m-0 verify-btn"
            (click)="changePassword()"
            [disabled]="
              changePasswordForm.invalid ||
              (newPassword !== confirmPassword && confirmPassword !== '')
            "
            [ngClass]="{
              'btn-change': changePasswordForm.invalid
            }"
          >
            Change Password
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
